export default __webpack_public_path__ + "static/media/debt-free.19403c2b.svg";